// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-btn[data-v-c579ebfc] {\n  white-space: normal !important;\n  line-height: 1.2;\n  height: auto !important;\n  min-width: 120px;\n  text-align: center;\n  max-width: -webkit-fill-available !important;\n  font-size: unset !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
